import React, { createContext, FC, useContext, useState } from 'react'

import { DefaultTheme, ThemeType } from '@/styles/theme'

type ContextType = { theme: ThemeType }

const ThemeContext = createContext<ContextType>({ theme: null })

const ThemeProvider: FC = ({ children }) => {
  const [theme] = useState(DefaultTheme)

  return <ThemeContext.Provider value={{ theme }}>{children}</ThemeContext.Provider>
}

const useTheme = (): ContextType => useContext(ThemeContext)

export { ThemeProvider, useTheme }
